import { api } from './client';

/** PUBLICIDAD (portado de Tony Boga, 4-nov-2026). Prefijo: /api/publicidad. Solo ADMIN. */

export interface FilaDeAnuncio {
  anuncioId: string | null;
  nombre: string;
  plataforma: string | null;
  clientes: number;
  compraron: number;
  /** compraron / clientes, en %. */
  tasa: number | null;
  vendido: number;
  costo: number | null;
  costoPorCliente: number | null;
  costoPorVenta: number | null;
  retorno: number | null;
}

export interface Publicidad {
  periodo: { desde: string; hasta: string };
  origen: { anuncio: number; organico: number; flota: number };
  ventas: {
    porAnuncio: { ventas: number; vendido: number };
    sinAnuncio: { ventas: number; vendido: number };
  };
  anuncios: FilaDeAnuncio[];
  invertido: number | null;
  anunciosSinCosto: number;
}

export const getPublicidad = (dias: number) => {
  const hasta = new Date();
  const desde = new Date(hasta.getTime() - dias * 86400_000);
  return api.get<Publicidad>(
    `/api/publicidad?desde=${desde.toISOString()}&hasta=${hasta.toISOString()}`,
  );
};
